define('modules/editor/views/correodirect_fields_itemview',['require','exports','module','base/collectionview','./correodirect_option_view','ldsh!../templates/correodirect_fields_itemview'],function(require, exports, module){
  "use strict";

  var CollectionView = require("base/collectionview"),
      OptionView = require("./correodirect_option_view");

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/correodirect_fields_itemview"),
    itemContainer: ".js-options",
    itemView: OptionView,
    events: {
      "change select": "updateIntegration",
      "click .js-expand": "toggleOptions"
    },
    initialize: function(options) {
      this.collection = options.model.items;
      this.initializeI18n();
    },
    collectionIterator: function(collection, fn, ctx) {
      if (this.model.hasIntegrableOptions) collection.each(fn, ctx);
    },
    helpers: function() {
      return {
        hasIntegrableOptions: this.model.hasIntegrableOptions
      };
    },
    initializeI18n: function() {
      _.each(_.keys(this.i18n), function(key){
        this.i18n[key] = $.i18n.t(this.i18n[key]);
      }, this);
    },
    i18n: {
      dropDownDefaultText: "integration.dropdownChooseOne",
    },
    defaultCorreoDirectFields: ["IP", "REFERER", "BirthYear", "BirthMonth", "BirthDay", "Sex", "Phone", "email", "ZipCode", "Fname", "Lname", "address", "City",
      "Profession", "Education", "Industry", "AreaIT", "VATNumber", "IDCard", "State", "Country", "Province", "TypeVia", "NumberAddress", "OperatorMobile", "Password"],
    onRender: function() {
      this._renderLists();
      this.$el.i18n();
    },
    _renderLists: function() {
      var combo = this.$(".js-correodirect-fields");
      combo.empty();
      combo.append($("<option />").text(this.i18n.dropDownDefaultText));
      //add default fields
      _.each(this.defaultCorreoDirectFields, function(name){
        var item = $("<option />")
          .attr("value", name)
          .text(name);
        var mappedField = this.model.get("correodirectBinding"); // [combo.data("field")];

        if(name === mappedField){
          item.attr("selected", "selected");
        }
        combo.append(item);
      }, this);
    },
    updateIntegration: function(e) {
      var value = this.$("select :selected").attr("value");
      this.model.set("correodirectBinding", value);
    },
    toggleOptions: function(e) {
      this.$(".js-options").toggleClass("hidden");
      this.$(".js-expand span").toggleClass("ed-icon-arrow-down2");
      this.$(".js-expand span").toggleClass("ed-icon-arrow-up2");
    }
  });
});

